import { ConcreteEncodable } from "./ConcreteEncodable";

import { FwdRollChangeResponseImplEncoder } from "../../encoder/FwdRollChangeResponseImplEncoder";

import * as CubiqTS from "../../index";
import { FwdRollChangeResponse } from "../FwdRollChangeResponse";

export class FwdRollChangeResponseImpl extends ConcreteEncodable implements FwdRollChangeResponse {
  public static enType: string = "com.bcdfx.model.fwdroll.FwdRollChangeResponseImpl";

  /*FID=1*/
  public updates: Array<CubiqTS.FwdRollPricingDataUpdate> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FwdRollChangeResponseImplEncoder.Instance;
    this.setEncodableType(FwdRollChangeResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FwdRollChangeResponseImpl[" + "updates=" + this.updates + "messageId=" + this.messageId + "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
